module.exports = __webpack_public_path__ + "img/djh.b6ec9655.png";